import { gridGutterHalf, gridGutter1q6, gridGutter1q3, fontSizeBase, fontSize24, fontSize12 } from '@maxmilhas/hangar-components-atomic/public/styles/components/quarks/layout'

export const item = `
  margin-bottom: ${gridGutterHalf}px;

  &:last-child {
    margin-bottom: 0;
  }
  
  label {
      margin-bottom: 0;
  }
`